import(/* webpackMode: "eager" */ "/home/runner/work/waitlistly/waitlistly/src/app/(auth)/forgot-password/page.tsx");
